import ReportDocument from "./ReportDocument";

const MISExpenseReports = ({ data = [] }) => {
  const columns = [
    { label: "Report ID", key: "report_id" },
    { label: "Employee Name", key: "employee_name" },
    { label: "Report Name", key: "report_name" },
    { label: "From Date", key: "start_date" },
    { label: "To Date", key: "end_date" },
    { label: "Submitted On", key: "submitted_on" },
    { label: "Amount", key: "total_amount" },
    { label: "Cost center", key: "cost_center" },
    { label: "Project", key: "project" },
    { label: "Status", key: "status" },
  ];

  const customFields = data[0]?.custom_fields?.map((ele) => ele.key) ?? [];

  return (
    <ReportDocument columns={columns} data={data} customFields={customFields} />
  );
};

export default MISExpenseReports;
